import { useEffect, useState } from "react";
import { api, fmtErr } from "../../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "home_intro", label: "Presentazione in Home", textarea: true, testid: "content-home-intro" },
  { key: "chi_sono", label: "Pagina Chi Sono (testo completo)", textarea: true, testid: "content-chi-sono" },
  { key: "quote", label: "Frase / citazione personale", textarea: false, testid: "content-quote" },
  { key: "contact_email", label: "Email di contatto", textarea: false, testid: "content-email" },
  { key: "contact_phone", label: "Telefono", textarea: false, testid: "content-phone" },
  { key: "contact_whatsapp", label: "WhatsApp (numero)", textarea: false, testid: "content-whatsapp" },
  { key: "contact_instagram", label: "Instagram (es. @cartomanziavera)", textarea: false, testid: "content-instagram" },
  { key: "address", label: "Indirizzo / zona (facoltativo)", textarea: false, testid: "content-address" },
  { key: "home_tagline", label: "Home — tagline sotto il titolo ARCANA", textarea: false, testid: "content-home-tagline" },
  { key: "home_methods_intro", label: "Home — testo sotto \"Scegli la tua lettura\"", textarea: true, testid: "content-home-methods-intro" },
  { key: "scopri_altro_intro", label: "Scopri altro — testo introduttivo", textarea: true, testid: "content-scopri-altro-intro" },
  { key: "piani_intro", label: "Piani — testo introduttivo", textarea: true, testid: "content-piani-intro" },
  { key: "promo_banner", label: "Comunicazione/promozione in evidenza in Home (vuoto = nascosta)", textarea: true, testid: "content-promo-banner" },
  { key: "desc_tarocchi", label: "Descrizione metodo: Tarocchi", textarea: false, testid: "content-desc-tarocchi" },
  { key: "desc_piacentine", label: "Descrizione metodo: Piacentine", textarea: false, testid: "content-desc-piacentine" },
  { key: "desc_rune", label: "Descrizione metodo: Rune", textarea: false, testid: "content-desc-rune" },
  { key: "desc_cielo", label: "Descrizione metodo: Il mio cielo", textarea: false, testid: "content-desc-cielo" },
  { key: "desc_coppia", label: "Descrizione metodo: La nostra Coppia", textarea: false, testid: "content-desc-coppia" },
  { key: "desc_numerologia", label: "Descrizione metodo: Numerologia", textarea: false, testid: "content-desc-numerologia" },
  { key: "desc_letture", label: "Descrizione: Le mie letture", textarea: false, testid: "content-desc-letture" },
];

export default function AdminContent() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content").then((r) => setForm(r.data)).catch(() => setForm({}));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", form);
      toast.success("Contenuti salvati.");
    } catch (e) {
      toast.error(fmtErr(e));
    } finally {
      setSaving(false);
    }
  };

  if (!form) return null;

  return (
    <div data-testid="admin-content-section">
      <h2 className="font-display text-2xl text-amber-100 mb-2">Contenuti e Contatti</h2>
      <p className="text-sm text-purple-300/60 mb-8">Modifica i testi delle pagine e i recapiti visibili sul sito. I campi vuoti mostrano un messaggio di cortesia.</p>

      <div className="mystic-card p-6 sm:p-8 space-y-6 max-w-2xl">
        {FIELDS.map((f) => (
          <label key={f.key} className="block space-y-1.5">
            <span className="text-xs text-purple-300/60">{f.label}</span>
            {f.textarea ? (
              <textarea
                className="input-dark min-h-[110px] resize-y"
                value={form[f.key] || ""}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={f.testid}
              />
            ) : (
              <input
                className="input-dark"
                value={form[f.key] || ""}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                data-testid={f.testid}
              />
            )}
          </label>
        ))}
        <button onClick={save} disabled={saving} data-testid="content-save-btn" className="gold-btn px-8 py-3 text-sm flex items-center gap-2 disabled:opacity-60">
          <Save className="w-4 h-4" /> {saving ? "Salvataggio…" : "Salva contenuti"}
        </button>
      </div>
    </div>
  );
}
